import React from "react";
import DashboardComponent from "./dashboardComponent";
import { history } from "../../managers/history";
import BaseComponent from "../baseComponent";
import { pathConstants } from "../../constants";

class Dashboard extends BaseComponent {
  constructor(props) {
    super(props);
    let url = [];
    if (history.location.pathname) url = history.location.pathname.split("/");

    if (url && url.length === 2)
      history.replace(pathConstants.DASHBOARD_MENU.HOME);
  }

  onMenuClick = (activeMenu) => {
    history.push({ pathname: activeMenu });
  };

  render() {
    return <DashboardComponent onMenuClick={this.onMenuClick} />;
  }
}

export default Dashboard;
